module.exports = __webpack_public_path__ + "img/mob.78152360.svg";